import * as React from "react";
import { styled } from "@mui/system";
import MUITableRow from "@mui/material/TableRow";
import {
  TableRowProps as TableRowPropsMUI,
  TableRowTypeMap
} from "@mui/material/TableRow";
import { OverridableComponent } from "@mui/material/OverridableComponent";
export interface TableRowProps extends TableRowPropsMUI {
  component?: React.ElementType;
}

const TableRowRoot = styled(MUITableRow, {
  name: "TableRow",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({
  "&.MuiTableRow-root.MuiTableRow-hover": {
    ":hover": {
      background: theme.palette.primary.interactiveSelectedColor
    }
  },
  "&.MuiTableRow-root.Mui-selected": {
    background: theme.palette.primary.interactiveSelectedColor
  },
  "&.MuiTableRow-root.MuiTableRow-head": {
    ":hover": {
      background: theme.palette.primary.surfaceDefault
    }
  }
}));

export const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>(
  function TableRow(props, ref) {
    return <TableRowRoot {...props} ref={ref} />;
  }
) as OverridableComponent<TableRowTypeMap<{}, "tr">>;
